import { useContext, useMemo } from 'react'
import { convertToBoolean } from '@/globalUtils/convertToBoolean'
import { context } from '@/Layout'

export default function useGlobalLoading() {
  const { introShown } = useContext(context)

  const loading = useMemo(() => {
    const result = convertToBoolean(introShown)

    return !result
  }, [introShown])

  return { loading }
}
